// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { ErrorDeviceRef, IErrorDeviceRef } from "./CoreApi.Data.ErrorDeviceRef.gen";
import { ErrorDetailsEntity, IErrorDetailsEntity } from "./CoreApi.Entities.ErrorDetailsEntity.gen";
import { ErrorIssueStatus } from "./Shared.ErrorIssueStatus.gen";
import { ErrorSeverity } from "./Shared.ErrorSeverity.gen";

export interface IErrorSummary {
	hashId: string | undefined;

	latestFirmware: string | undefined;

	firstFirmware: string | undefined;

	firstOccurrence: string | undefined;

	lastOccurrence: string | undefined;

	count: number;

	count24h: number;

	count7d: number;

	count30d: number;

	devices: IErrorDeviceRef[] | undefined;

	status: ErrorIssueStatus;

	severity: ErrorSeverity | undefined;

	statusChangedByName: string | undefined;

	details: IErrorDetailsEntity | undefined;

	$type?: string | undefined;
}
export class ErrorSummary {
	constructor(data?: IErrorSummary) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.firstOccurrence) { this.firstOccurrence = new Date(data.firstOccurrence); }
		if (data.lastOccurrence) { this.lastOccurrence = new Date(data.lastOccurrence); }
		this.devices = data.devices ? data.devices.map((d: any) => new ErrorDeviceRef(d)) : [];
		if (data.details) { this.details = new ErrorDetailsEntity(data.details); }
	}

	hashId: string | undefined;

	latestFirmware: string | undefined;

	firstFirmware: string | undefined;

	firstOccurrence: Date | undefined = new Date();

	lastOccurrence: Date | undefined = new Date();

	count: number = 0;

	count24h: number = 0;

	count7d: number = 0;

	count30d: number = 0;

	devices: ErrorDeviceRef[] | undefined = [];

	status: ErrorIssueStatus = 0;

	severity: ErrorSeverity | undefined;

	statusChangedByName: string | undefined;

	details: ErrorDetailsEntity | undefined;

	static $type: string = "CoreApi.Data.ErrorSummary, ";
	$type?: string | undefined = ErrorSummary.$type;
}

